import { useRouter } from 'next/router';
import * as React from 'react';

import { useCanViewGroupContent } from '@/hooks/useCanViewGroupContent';
import { Loading } from '@/imports/ui/chakra/components/Loading';
import { NotAllowedToViewContent } from '@/imports/ui/pages/group/NotAllowedToViewContent';

import { GroupMembers } from '../../GroupMembers';
import { GroupPageLayout } from '../GroupPageLayout';
import { NoAccess } from '@/imports/ui/chakra/components/NoAccess';


export const GroupMembersPane: React.FC = () => {
  const router = useRouter();
  const { groupId } = router.query;

  const { loading, canViewGroupContent, communityVisibility, isCurrentUserIsAdmin } = useCanViewGroupContent(
    groupId.toString()
  );
  if (loading) {
    return <Loading />;
  }

  if (communityVisibility === "HIDDEN" && !isCurrentUserIsAdmin) {
    return <NoAccess message="This group has been hidden by your administrator and can't be accessed. For questions or concerns, contact your administrator."/>;
  }
  return (
    <GroupPageLayout>
      {loading ? (
        <Loading />
      ) : !canViewGroupContent ? (
        <NotAllowedToViewContent />
      ) : (
        <GroupMembers
          groupId={groupId.toString()}
          getUserLink={(userId: string) => `/members/${userId}`}
        />
      )}
    </GroupPageLayout>
  );
};
